import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.337 7.513C8.203 5.36 10.22 4 12.412 4c2.19 0 4.208 1.36 5.074 3.513.776 1.93.165 4.015-1.434 6.546l-3.64 5.08-3.641-5.08c-1.6-2.531-2.21-4.616-1.434-6.546zm12.004-.747c1.16 2.885.07 5.734-1.63 8.412l-4.708 6.568a.822.822 0 01-.591.254.822.822 0 01-.592-.254l-4.708-6.568c-1.7-2.678-2.79-5.527-1.63-8.412C6.642 3.881 9.377 2 12.412 2c3.034 0 5.769 1.881 6.93 4.766zM12.5 6a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM11 9.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z",
      fill: "#2d6ded"
    }
  )
), o = t;
export {
  o as default
};
